import { LinkClickedEvent, TextFieldBlurEvent } from '@atlassian/mpac-analytics';
import { ANALYTICS_EVENT_CONTAINER_PRICING_TAB, ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE, ANALYTICS_SUBJECT_ID_USER_COUNT } from '../../analytics/Events';
import { VIEW_DIFFERENT_TIERS_PRICING } from './tabs/PricingTab/PricingTab.constants';
export const additionalPricingDetailsModalOpenedEvent = billingCycle => {
  return {
    eventType: LinkClickedEvent,
    actionSubjectId: ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE,
    attributes: {
      billingCycle,
      label: VIEW_DIFFERENT_TIERS_PRICING,
      eventContainer: ANALYTICS_EVENT_CONTAINER_PRICING_TAB
    }
  };
};
export const pricingCalculatorUserCountBlurEvent = (billingCycle, userCount) => {
  return {
    eventType: TextFieldBlurEvent,
    actionSubjectId: ANALYTICS_SUBJECT_ID_USER_COUNT,
    attributes: {
      billingCycle,
      userCount,
      eventContainer: ANALYTICS_EVENT_CONTAINER_PRICING_TAB
    }
  };
};